module.exports = __webpack_public_path__ + "static/media/MuttonCurry.e0c02736.jpg";